var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCollapse({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.71 11.29L11.71 7.29C11.4563 7.03634 11.0866 6.93728 10.7401 7.03012C10.3936 7.12297 10.123 7.39362 10.0301 7.74012C9.93728 8.08663 10.0363 8.45634 10.29 8.71L12.59 11H4C3.44772 11 3 11.4477 3 12C3 12.5523 3.44772 13 4 13H12.59L10.29 15.29C10.1007 15.4778 9.9942 15.7334 9.9942 16C9.9942 16.2666 10.1007 16.5222 10.29 16.71C10.4778 16.8993 10.7334 17.0058 11 17.0058C11.2666 17.0058 11.5222 16.8993 11.71 16.71L15.71 12.71C15.801 12.6149 15.8724 12.5028 15.92 12.38C16.02 12.1365 16.02 11.8635 15.92 11.62C15.8724 11.4972 15.801 11.3851 15.71 11.29ZM19 4C18.4477 4 18 4.44772 18 5V19C18 19.5523 18.4477 20 19 20C19.5523 20 20 19.5523 20 19V5C20 4.44772 19.5523 4 19 4Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapse);
export default ForwardRef;